import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface EntityCardMetaItem {
  label: string;
  value: ReactNode;
}

export interface EntityCardProps {
  title: ReactNode;
  subtitle?: ReactNode;
  badge?: ReactNode;
  meta?: EntityCardMetaItem[];
  footer?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export default function EntityCard({
  title,
  subtitle,
  badge,
  meta = [],
  footer,
  children,
  className,
}: EntityCardProps) {
  return (
    <article className={cn('rounded-xl border border-gray-200 bg-white p-4 shadow-sm', className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          {subtitle && <p className="mt-1 text-xs text-gray-500">{subtitle}</p>}
        </div>
        {badge}
      </div>

      {meta.length > 0 && (
        <dl className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
          {meta.map((item) => (
            <div key={item.label}>
              <dt className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">{item.label}</dt>
              <dd className="text-sm text-gray-900">{item.value}</dd>
            </div>
          ))}
        </dl>
      )}

      {children && <div className="mt-3">{children}</div>}
      {footer && <div className="mt-4">{footer}</div>}
    </article>
  );
}
